import { IconUser16 } from '@warp-ds/icons/react/user-16';
import { Dropdown } from '../../common/Dropdown';
import { FrontPageModal } from '../../common/frontPageModal/FrontPageModal';
import { PaxCombination } from './PaxCombination';

export type PaxSelectorProps = {
    numberOfAdults: number;
    agesOfChildren: number[];
    onChange: (adults: number, childrenAges: number[]) => void;
};

export const formatPaxTriggerLabel = (numberOfAdults: number, agesOfChildren: number[]) => {
    const adultText = numberOfAdults === 1 ? '1 voksen' : `${numberOfAdults} voksne`;
    const childrenText = agesOfChildren.length > 0 ? `, ${agesOfChildren.length} barn` : '';
    return `${adultText}${childrenText}`;
};

export const PaxSelector = ({ numberOfAdults, agesOfChildren, onChange }: PaxSelectorProps) => {
    const triggerLabel = formatPaxTriggerLabel(numberOfAdults, agesOfChildren);
    const label = 'Reisende';
    const icon = <IconUser16 aria-hidden />;

    return (
        <>
            <Dropdown
                trigger={{
                    text: triggerLabel,
                    label,
                }}
                prefix={icon}
                className="hidden sm:flex">
                <PaxCombination numberOfAdults={numberOfAdults} agesOfChildren={agesOfChildren} updatePax={onChange} />
            </Dropdown>
            <FrontPageModal
                breakpoint="sm"
                title={label}
                trigger={{
                    text: triggerLabel,
                    prefix: icon,
                }}>
                <PaxCombination numberOfAdults={numberOfAdults} agesOfChildren={agesOfChildren} updatePax={onChange} />
            </FrontPageModal>
        </>
    );
};
